export default __webpack_public_path__ + "static/media/profile-img.ea071cf0.png";